import { Error404Page } from '@components/modules/error';
import { isValidUuid } from '@shared/utils';
import React from 'react';
import { useParams } from 'react-router-dom';

type Props = {
  paramName: string;
  children: React.ReactElement;
};

export const ValidUuidGuard: React.FC<Props> = ({ paramName, children }) => {
  const params = useParams();
  const value = params[paramName];

  if (value !== undefined && !isValidUuid(value)) {
    return <Error404Page source="uuid-guard" detail={`param "${paramName}" = "${value}"`} />;
  }

  return children;
};

ValidUuidGuard.displayName = 'ValidUuidGuard';
